import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';
import type { PortalNavigator } from '../models/portal/PortalNavigator';
import type { TicketModel } from '../models/ticket/TicketModel';

export interface SearchInput {
  search: string;
  application?: string;
  applicationId?: string;
  fields?: string[];
  default_operator?: string;
  fuzziness?: string;
  query?: any;
  params?: {
    pageSize?: number;
    pageIndex?: number;
    portalNavigator?: PortalNavigator;
  };
  returnFields?: string[];
  returnParentFields?: string[];
}

export interface SearchOutput {
  researchRegisterId?: string;
  total?: number;
  ticket?: TicketModel;
  chatId?: string;
  return?: CatalogNode[];
}

export async function search(input: SearchInput): Promise<FetchResponse<SearchOutput>> {
  return await portalCustomAPI.fetch<SearchInput, SearchOutput>('search', input);
}
